$(".bestsellers").slick({
    slidesToShow: 4,
    arrows: false,
    variableWidth: true,
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 1025,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
            }
        },]

})


